export default "__VITE_ASSET__MCqq7I1b__"